import React from 'react';
import { Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useActivities } from '../context/ActivitiesContext';
import CommunityCard from '../components/CommunityCard';
import { CardSkeleton } from '../components/Skeleton';
import EmptyState from '../components/EmptyState';
import { Users } from 'lucide-react';

const Communities = () => {
  const { communities, loading } = useActivities();

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-16 text-center md:text-left">
        <div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight mb-3">Community Hubs</h1>
          <p className="text-gray-500 font-medium text-lg md:text-xl max-w-2xl">Persistent ecosystems where knowledge lives beyond the session.</p>
        </div>
        <Link to="/c/new" className="flex items-center gap-2 bg-brand-indigo text-white px-10 py-4 md:py-5 rounded-2xl font-bold shadow-xl shadow-brand-indigo/20 hover:bg-brand-indigo/90 transition-all active:scale-[0.98] text-[10px] uppercase tracking-[0.15em] shrink-0">
           <Plus size={20} />
           Create New Hub
        </Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {loading ? (
          Array(6).fill(0).map((_, i) => <CardSkeleton key={i} />)
        ) : Array.isArray(communities) && communities.length > 0 ? (
          communities.map((community) => (
            <CommunityCard 
              key={community.id}
              community={community}
            />
          ))
        ) : (
          <div className="col-span-full">
            <EmptyState 
              icon={Users}
              title="No communities found"
              description="Discover or create your first community hub to start participating."
              action={
                <Link to="/c/new" className="inline-flex items-center gap-2 bg-brand-indigo text-white px-8 py-3 rounded-xl font-bold text-sm shadow-lg shadow-brand-indigo/20 hover:bg-brand-indigo/90 transition-all">
                  <Plus size={18} />
                  Create Your First Hub
                </Link>
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Communities;
